export const getInitialState = (): any => ({
  healthData: {}
});
